import EmailVerificationSuccess from '@/components/auth/email-verification-success/EmailVerificationSuccess.vue';
import { usePostHog } from '@/composables/usePostHog';
import { getMe } from '@/services/auth';
import { useUserStore } from '@/stores/users';
import PageNotFound from '@/views/NotFound.vue';
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { merchantRoutes } from './merchant';
import { shopperRoutes } from './shopper';

usePostHog();

export const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: PageNotFound,
  },
  {
    path: '/',
    redirect: '/shopper/auth/sign-in',
  },
  shopperRoutes,
  merchantRoutes,
  {
    path: '/email-verification-success',
    name: 'EmailVerificationSuccess',
    component: EmailVerificationSuccess,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  // Users need to be signed in to view authenticated pages. Try to sign them in if they are not.
  if (to.meta.requiresAuth) {
    const userStore = useUserStore();
    // TODO: Please add this check back once this app is the only dashboard. We have to do these checks as the user might have signed out via another dashboard.
    // if (!userStore.isAuthenticated) {
    try {
      // The token might be expired but if they are still logged in (remember me), we can refresh the user data.
      userStore.user = await getMe();
      // If the user is trying to access a page that is not for their role, redirect them to the sign-in page.
      if ((userStore.user.role === 'MERCHANT' || userStore.user.role === 'ADMIN') && to.path.startsWith('/shopper')) {
        return { name: 'shopperSignIn' };
      } else if (userStore.user.role === 'CLIENT' && to.path.startsWith('/merchant')) {
        return { name: 'merchantSignIn' };
      }
      return;
    } catch (error: any) {
      await userStore.signOut();
      const getChannelFromUrl = to.path.split('/');
      const channel = getChannelFromUrl[1] || 'shopper';
      return {
        name: channel === 'merchant' ? 'merchantSignIn' : 'shopperSignIn',
        query: { redirect: to.fullPath },
      };
    }
  }
});

export default router;
